<template>
  <el-dialog
    title="支付通道配置"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >


    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="微信" name="first">
        <el-radio v-model="form.wx_pz_type" label="1" border>微信服务商</el-radio>
        <el-radio v-model="form.wx_pz_type" label="2" border>乐刷</el-radio>
        <el-radio v-model="form.wx_pz_type" label="3" border>银盛</el-radio>
        <el-radio v-model="form.wx_pz_type" label="4" border>随行付</el-radio>
      </el-tab-pane>
      <el-tab-pane label="支付宝" name="second">
        <el-radio v-model="form.zfb_pz_type" label="1" border>支付宝服务商</el-radio>
        <el-radio v-model="form.zfb_pz_type" label="2" border>乐刷</el-radio>
        <el-radio v-model="form.zfb_pz_type" label="3" border>银盛</el-radio>
        <el-radio v-model="form.zfb_pz_type" label="4" border>随行付</el-radio>
        </el-tab-pane>
    </el-tabs>




      <div style="text-align: center;margin-top: 30px;">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </div>
    </el-form>
  </el-dialog>

</template>
<style>

  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
export default {
  name: "payconfigureEditForm",
  props: {
      agent: Object,
      accuseVisible:Boolean,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
        accuseVisible2:true,
        formEdit2: true,
      loading: false,
      dialogVisible: false,
        activeName: 'first',
      form: {
          wx_pz_type:'',
          zfb_pz_type:''
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
      accuseVisible (newValue, oldValue) {
          console.log("-----"+newValue);
          this.accuseVisible2 = newValue;
      },
      handleClick(){

      },
      dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
        this.form.wx_pz_type="";
        this.form.zfb_pz_type="";
        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("agentid",this.agent.agentid);
        agentService.getPerfectAgent(formData4).then(data => {
            if(data!=null && data!=""){
                console.log("data.wx_pz_type===="+data.wx_pz_type);
                if(data.wx_pz_type!=null && data.wx_pz_type!=""){
                    this.form.wx_pz_type=data.wx_pz_type;

                }
                if(data.zfb_pz_type!=null && data.zfb_pz_type!="") {
                    this.form.zfb_pz_type = data.zfb_pz_type;
                }


            }
        });


    },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
                this.loading = true;
                agentService.saveAgentPz({ ...this.form,agentid:this.agent.agentid})
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });
        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

